import axios from 'axios';
import { Loading,Message } from 'element-ui';
import Router from '../router/index.js'
import { utils } from '@/common/common.js'
//这里是调用的衣加加app的接口
const url_app={
    jp_computer_url: 'http://10.10.1.147:10011',  // 江鹏的电脑： http://10.10.1.147:10011
    sjr_computer_url: 'http://10.10.1.128:10011',  // 宋佳融的电脑： http://10.10.1.128:10011
    dev_url: 'https://api.dev.ysintelligent.com/yijiajia_app',  // 线上开发环境接口
    test_url: 'https://api.test.ysintelligent.com/yijiajia_app',  // 线上测试环境接口,
	prod_url: 'https://api.ysintelligent.com/yijiajia_app', // 线上生产环境接口
	
	dev_onlinePayUrl_prefix:'https://api.dev.ysintelligent.com/yijipay', // 线上开发环境 - 支付相关 前缀
	test_onlinePayUrl_prefix:'https://api.test.ysintelligent.com/yijipay', // 线上测试环境 - 支付相关 前缀
	prod_onlinePayUrl_prefix:'https://api.ysintelligent.com/yijipay', // 线上生产环境 - 支付相关 前缀
}
//根据环境 改变接口地址 
var environmental=utils.getCurrentApi()
var resultApi={}
if(environmental=='dev'){
    resultApi={
    	baseUrl:url_app.dev_url,
    	onlinePayUrl:url_app.dev_onlinePayUrl_prefix
    } 
}
if(environmental=='test'){
    resultApi={
    	baseUrl:url_app.test_url,
    	onlinePayUrl:url_app.test_onlinePayUrl_prefix
    } 
}
if(environmental=='prod'){
    resultApi={
    	baseUrl:url_app.prod_url,
    	onlinePayUrl:url_app.prod_onlinePayUrl_prefix
    } 
}

export const api_app=resultApi
var instance = axios.create({
	baseURL: api_app.baseUrl,
	timeout: 20000,
	headers: {
		'weiweiHeader': 'app66'
	}
});
// function getCookie(cname) {
//         var name = cname + "=";
//         var ca = document.cookie.split(';');
//         for (var i = 0; i < ca.length; i++) {
//             var c = ca[i].trim();
//             if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
//         }
//         return "";
// }
// function getToken_Yjj(){
//         let oUserInfo=JSON.parse(getCookie('userInfo_multiActive'))
//         return oUserInfo.yijiajiaUserToken
// }
export function ajaxApp(url, data) {
    
    let args = { 
       ...data,
       "token":utils.getToken_Yjj(),
       "functionSysId":utils.getSysId(),
       "functionAdminId":utils.getAdminId()
    };
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post', 
			url: url,
			data:args
		}).then(function(response) {
			// console.log(response,'response')
			if(!response.data.errorCode){
				Message({
					message: "返回数据格式异常 ",//接口返回一个页面
					type: 'error',
					duration: 1500
				});
			}else if(response.data.errorCode == -20000){
                
			}else{
				if(response.data.errorCode == 200){
					
				}else{
					Message({
						message:response.data.errorMsg,
						type: 'error',
						duration: 1500
					});
				}
				
			}
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p
	
}



// WEBPACK FOOTER //
// ./src/common/request_app.js